export default "__VITE_ASSET__cU8SK4th__"